import { useSelector, useDispatch } from 'react-redux';
import { formatUnixDate } from 'controls/utils';
import { deactivateEntitlement } from 'actions/entitlements';
import { Header } from 'components/atoms/Header/Header';
import UserContainer from 'components/user/container/UserContainer';
import Table from 'components/table/Table';
import DownloadTable from 'components/download/DownloadTable';
import { Language } from 'language/Language';
import { licensesStrings } from './strings';

const Entitlement = () => {
  const { entitlement, order } = useSelector((state) => state);
  const language = Language();
  const dispatch = useDispatch();

  const handleDeactivate = (id) => {
    dispatch(deactivateEntitlement(id));
  };

  const EntitlementHero = () => (
    <div>
      <p>
        {' Order # '}
        <span className='highlighted-text'>{order?.orderID}</span>
        {' was placed on '}
        <span className='highlighted-text'>{formatUnixDate(order?.createdAtUnixEpoch)}</span>
        {' and is currently '}
        <span className='highlighted-text'>{` ${order?.status}`}</span>
        .
      </p>
    </div>
  );

  return (
    <UserContainer>
      <>
        {entitlement
          ? (
            <div style={{ width: '100%' }}>
              {order && <EntitlementHero />}
              <Header text={entitlement?.name} />
              <p>
                {`${licensesStrings[language].enabled}: `}
                <strong>
                  <span className='highlighted-text'>{entitlement.enabled ? 'yes' : 'no'}</span>
                </strong>
              </p>
              <Table>
                <>
                  <h1 className='tc'>{licensesStrings[language].status}</h1>
                  <Table.Content>
                    <>
                      <div className='table-row' style={{ height: 'auto' }}>
                        <div className='table-content__item center'>
                          {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                          <h3>{licensesStrings[language].devices} {entitlement?.devicesUsed} / {entitlement?.maxDevices}</h3>
                        </div>
                        {entitlement?.devicesUsed > 0
                            && (
                              <div className='table-content__item'>
                                <button
                                  type='button'
                                  className='table-content__link'
                                  onClick={() => handleDeactivate(entitlement?.entitlementID)}
                                >
                                  <h3>{licensesStrings[language].unlink}</h3>
                                </button>
                              </div>
                            )}
                      </div>
                    </>
                  </Table.Content>
                </>
              </Table>
              <Header text={licensesStrings[language].download} />
              <DownloadTable dataToMap={entitlement || []} />
            </div>
          )
          : (
            <p>No license has been made yet.</p>
          )}
      </>
    </UserContainer>
  );
};

export default Entitlement;
